import React from 'react';
import { connect } from 'react-redux';
import Scroll from 'react-scroll'; // Imports all Mixins
import { Col, Grid, Row, Button, FormControl, ControlLabel, ButtonToolbar, FormGroup } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { forgotPassword } from '../../actions/login';
import './styles.css';

class ForgottenPage extends React.Component<{}> {
  constructor(props) {
    super(props);
    this.state = { value: '', submitted: false, touched: false };
  }
  componentDidMount() {
    const scroll = Scroll.animateScroll;
    scroll.scrollToTop({ duration: 0 });
  }

  handleChange = e => {
    this.setState({ value: e.target.value, touched: true });
  };

  handleRestore = () => {
    if (this.state.value === '') {
      this.setState({ touched: true });
      return;
    }
    this.setState({ submitted: !this.state.submitted }, async () => {
      if (this.state.submitted) {
        return await this.props.forgotPassword(this.props.basket.data.id, {
          username: this.state.value,
          url: window.location.hostname
        });
      }
    });
  };

  render() {
    if (this.state.submitted && this.state.value && this.props.forgot.forgotSuccess) {
      return (
        <div className="forgotten">
          <Grid>
            <Row>
              <Col xs={12}>
                <h2>Forgotten Your Password?</h2>
                <br />
                <h5>An email with instructions on how to reset your password has been sent.</h5>
                <ButtonToolbar>
                  <Button bsStyle="primary" onClick={this.handleRestore} style={{ borderRadius: 0 }}>
                    Resend Email?
                  </Button>
                </ButtonToolbar>
              </Col>
            </Row>
          </Grid>
        </div>
      );
    }

    return (
      <div className="forgotten">
        <Grid>
          <Row>
            <Col xs={12}>
              <h2>Forgotten Your Password?</h2>
              <FormGroup
                validationState={
                  this.state.touched ? (this.state.value && !this.state.submitted ? null : 'error') : null
                }
              >
                <ControlLabel>Username (usually email address)</ControlLabel>
                <FormControl value={this.state.value} placeholder="Username" onChange={this.handleChange} type="text" />
                <FormControl.Feedback />
              </FormGroup>
              <h5>Please enter your username and we'll send you an email to reset your password</h5>
              <h5 style={{ color: 'red' }}>
                {this.props.forgot.hasFailed
                  ? this.props.forgot.errorMessage[0] && this.props.forgot.errorMessage[0]['message']
                  : null}
              </h5>
              <br />
              <Button bsStyle="primary" onClick={this.handleRestore} style={{ borderRadius: 0 }}>
                Restore
              </Button>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      user: state.user,
      basket: state.basket,
      forgot: state.login.forgot
    }),
    { forgotPassword }
  )(ForgottenPage)
);



// WEBPACK FOOTER //
// ./src/containers/ForgottenPage/index.js